// extracted by mini-css-extract-plugin
export default {"title":"DiplomaValid_title__4Xk8-"};